// extracted by mini-css-extract-plugin
export default {"list":"ProfileList_list__xw-LW","btn":"ProfileList_btn__cI+Y+","link":"ProfileList_link__TlnBp"};